import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/* Volta a rolagem ao topo quando o painel troca de "página" sem desmontar
 * (drill-down do Gestor, breadcrumb de volta, turma -> aluno no drawer). Sem
 * isso o conteúdo novo aparece na posição de rolagem antiga, e os cards que
 * dependem de entrar no viewport podem nunca disparar a animação de entrada.
 *
 * No projeto de origem isto era `#painel-scroll`, o <main> do AppShell — que
 * não existe no AVA. Verificado no CSS do CoreUI: `.c-body` é
 * `display:flex; flex-grow:1` SEM overflow, ou seja quem rola é a janela. O
 * teste de scrollHeight fica como defesa caso o layout mude. */
export function scrollPainelTopo() {
  const c = document.querySelector(".c-body");
  if (c && c.scrollHeight > c.clientHeight) {
    c.scrollTo({ top: 0 });
    return;
  }
  window.scrollTo({ top: 0 });
}
